import {
  ChangeEvent,
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
} from 'react'

import { Credentials } from '../hooks/useProfileFormController'
import { AnyProfile } from '../types'
import { ProfileSection } from '../utilFunctions/buildProfileSection'

export interface FormActions {
  updateInput: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => void
  updateState: (key: string, value: number | string | string[] | null) => void
  handleCoverUpload: (refId: string, blob: Blob) => Promise<string>
  handleCredentials: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => void
}

type ProfileFormCtx = {
  values: AnyProfile
  formActions: FormActions
  isNewUser: boolean
  reset: () => void
  save: () => Promise<void>
  create: () => Promise<{ verificationLink?: string } | null>
  cancel: () => void
  isDirty: boolean
  loading: boolean
  sections: ProfileSection[]
  credentials: Credentials
  saveCredentials: (
    setShowModal: Dispatch<SetStateAction<boolean>>,
  ) => Promise<void>
}

const Ctx = createContext<ProfileFormCtx | null>(null)

export const ProfileFormProvider = ({
  value,
  children,
}: {
  value: ProfileFormCtx
  children: React.ReactNode
}) => <Ctx.Provider value={value}>{children}</Ctx.Provider>

export const useProfileForm = () => {
  const ctx = useContext(Ctx)
  if (!ctx)
    throw new Error('useProfileForm must be used within ProfileFormProvider')
  return ctx
}
